import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { CARGO_ITEM_STATUS_HISTORY } from 'api/query-keys.ts';
import type { CargoItemStatusRes } from 'api/swagger';

interface IParams {
  cargoId: number;
  cargoItemId: number;
  enabled?: boolean;
}

export const useGetCargoItemStatusHistory = (params: IParams) => {
  const { cargoItemId, cargoId, enabled = true } = params;

  return useQuery<CargoItemStatusRes[]>({
    queryKey: [CARGO_ITEM_STATUS_HISTORY, cargoId, cargoItemId],
    queryFn: async () => {
      try {
        const { data } = await http.get<CargoItemStatusRes[]>(
          `/v1/cargo/${cargoId}/cargo-items/${cargoItemId}/statuses`,
        );
        return data;
      } catch (error) {
        return returnIfNotFoundError<[]>(error, []);
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 5 * 1000,
    enabled,
  });
};
